<template>
    <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
        <custom-heading 
            :breadcrumbs="breadcrumbs"
        />

        <v-row>
            <v-col cols="9">
            <v-card elevation="2">
                <v-container>
                    <v-row>
                        <v-col class="d-flex justify-center">
                            <h2>Osnovni Podaci</h2>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="d-flex align-end flex-column" cols="4">
                            <p>Naziv:</p>   
                            <p>Županija:</p>   
                            <p>Općina:</p>   
                            <p>Adresa:</p>   
                            <p>Telefon:</p>   
                            <p>Kontakt mail:</p>   
                            <p>Informatička podrška:</p>   
                            <p>Ravnatelj:</p>   
                        </v-col>
                        <v-col cols="8">
                            <p>{{ items.name }}</p>
                            <p>-</p>
                            <p>-</p>
                            <p>{{ items.address }}</p>
                            <p>{{ items.contact_phone }}</p>
                            <p>{{ items.contact_email }}</p>
                            <p>{{ items.contact_it }}</p>
                            <p>-</p>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            </v-col>
            <v-col cols="3">
                <v-btn color="primary" @click="showAddForm()" block>
                    Uredi Podatke
                </v-btn>
                <!--Dodati mogucnost za brisanje skole-->
                <v-btn class="mt-4" color="primary" @click="deleteItem()" block outlined>
                    Obriši školu
                </v-btn>
            </v-col>
        </v-row>
        
    </v-container>
</template>

<script>
    import CustomHeading from "../heading/CustomHeading";
    import {serverBus} from "../../main";
    export default {

        components: {
            CustomHeading
        },

        created: function () {
            //Event bus za brisanje skole
            serverBus.$on('delete-item', (item) => {
                this.deleteItem(item);
            });

            var schoolId = this.$route.params.skola_id
            let table = 'skola' + '/' + `${schoolId}`;
            this.$store.commit('setTable', table);

            this.show_add_view = this.$route.matched[0].name === 'AddView';
            this.show_table_view = this.$route.matched[0].name === 'SingleSchoolTableView';

            this.$axios.post('skola/' +  `${schoolId}`).then(response => {
                this.breadcrumbs.push({text: response.data.name})
            });

            serverBus.$on('show-add-form', (item) => {
                if (this.$useDialog()===false) {
                    serverBus.$emit('show-add-edit-dialog', table, item);
                } else {
                    this.$router.push({name:'AddView', params:{table: 'skola', resource_id: `${schoolId}`}});
                }
            });
        },
        mounted(){
            //Get data for school
            this.getData()
        },

        methods: {
            showAddForm: function () {
                serverBus.$emit('show-add-form', {id: -1});
            },
            
            getData() {
                this.$axios.post(this.$getTable() + '')
                .then(response => {
                    this.items = response.data
                });
            },

            deleteItem() {
                serverBus.$emit('show-delete-item-dialog', 'skola', {id: this.$route.params.skola_id});
               
            },

        },

        beforeDestroy() {
            this.$destroyEvents();

            serverBus.$off('delete-item');
        },


        data: function () {
            return {
                breadcrumbs: [
                    {text: 'Administracija'},
                    {text: 'E-matica'},
                    {text: 'Škole'}
                ],
                show_add_view: false,
                show_table_view: false,
                items: {}
            };
        }
    }
</script>